<script setup>
import StandardInventoryDashboard from '~/dashboard/components/standard-dashboard/standard-inventory-dashboard.vue';
import StandardMapDashboard from '~/dashboard/components/standard-dashboard/standard-map-dashboard.vue';
import StandardScanReportDashboard from '~/dashboard/components/standard-dashboard/standard-scan-report-dashboard.vue';
import { useDashboardStore } from '~/dashboard/store/dashboard.store.js';

defineProps({
  show_sidebar: {
    type: Boolean,
    default: false,
  },
});

const route = useRoute();
const dashboard_store = useDashboardStore();
</script>

<template>
  <div>
    <StandardMapDashboard v-if="dashboard_store.current_dashboard?.report_data?.module === 'maps'" :show_sidebar="show_sidebar" />
    <StandardInventoryDashboard v-else-if="dashboard_store.scope === 'inventory'" />
    <StandardScanReportDashboard
      v-else-if="dashboard_store.current_dashboard?.report_data?.module === 'scan-report'"
      :class="dashboard_store.is_mobile_view ? '!w-full' : route.params.asset_id && !show_sidebar ? '!w-[calc(100vw-310px)]' : '!w-[calc(100vw-30px)]'"
    />
  </div>
</template>
